import React from 'react'
import { Form } from 'react-bootstrap'

export default function File(props) {

    const { label_name, disabled, name, onChange, onBlur,required, error } = props

    return (
        <>
            <Form.Group className="mb-3" controlId="file">
                <Form.Label className='form_label'>{label_name}{required == true ? <span className='required_filed'>*</span>:""}</Form.Label>
                <Form.Control
                    type="file"
                    disabled={disabled}
                    className='form_input'
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                />
                {error}
            </Form.Group>
        </>
    )
}
